import { useEffect } from 'react';

import { request } from 'app/utils';
import { Carousel, HeadersApiResponse, useHeader } from 'features/headers';
import { useSchool } from 'features/school';

const HeadersCarousel = () => {
  const { apiGatewayUrl } = useSchool();
  const { headers, setHeaders, clearHeaders } = useHeader();

  const fetch = async () => {
    await request<HeadersApiResponse>({
      url: '/api/v1/School/Headers',
      method: 'get',
      baseURL: apiGatewayUrl,
    }).then((response) => {
      setHeaders(response.data);
    });
  };

  useEffect(() => {
    fetch();

    return () => {
      clearHeaders();
    };
  }, []);

  return <Carousel headers={headers} />;
};

export default HeadersCarousel;
